
import { useState, useEffect } from 'react';
import Button from '../base/Button';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/99b3d317-3bd9-42d4-901f-9edec7626bfe.png" 
              alt="町家珈琲ロゴ" 
              className="w-10 h-10 object-contain"
            />
            <h1 className={`text-2xl font-bold transition-colors duration-300 ${
              isScrolled ? 'text-amber-900' : 'text-white'
            }`} style={{ fontFamily: 'Noto Serif JP, serif' }}>
              町家珈琲
            </h1>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('hero')}
              className={`transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-800' : 'text-white hover:text-amber-200'
              }`}
            >
              ホーム
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-800' : 'text-white hover:text-amber-200'
              }`}
            >
              当店について
            </button>
            <button 
              onClick={() => scrollToSection('menu')}
              className={`transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-800' : 'text-white hover:text-amber-200'
              }`}
            >
              メニュー
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-800' : 'text-white hover:text-amber-200'
              }`}
            >
              こだわり
            </button>
            <button 
              onClick={() => scrollToSection('testimonials')}
              className={`transition-colors duration-300 cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-amber-800' : 'text-white hover:text-amber-200'
              }`}
            >
              お客様の声
            </button>
            <Button 
              onClick={() => scrollToSection('contact')}
              size="sm"
              className="ml-4"
            >
              お問い合わせ
            </Button>
          </div>

          <div className="md:hidden">
            <i className={`ri-menu-line text-2xl cursor-pointer ${
              isScrolled ? 'text-gray-700' : 'text-white'
            }`}></i>
          </div>
        </div>
      </div>
    </nav>
  );
}
